<template>
  <main
    class="main m_payment_search_list"
    role="main"
    v-show="show"
    v-if="mobilePlanCategory"
  >
    <div class="main_con">
      <div class="list_con_top" :class="{ tab_fix: isTabFixed }">
        <!-- <div class="search_wrap">
          <div class="search_input">
            <div class="s_input">
              <input
                v-model="searchText"
                placeholder="갤럭시 Z Flip 4"
                maxlength="20"
                @keypress.enter="searchTextSend"
                ref="searchInput"
              />
            </div>
            <div class="s_del" @click="searchTextDel" v-if="isCloseBtn">
              <img
                :src="require(`@/assets/front/images/new/i_x_input.svg`)"
                alt=""
              />
            </div>
            <div class="s_search" @click="searchTextSend">
              <img
                :src="require(`@/assets/front/images/new/i_search_n.svg`)"
                alt=""
              />
            </div>
          </div>
        </div> -->
        <div class="network_wrap">
          <div class="network">
            <ul>
              <li
                v-for="(item, index) in mobilePlanCategory.networks"
                :key="index"
              >
                <p
                  :class="{ on: networkType == item.networkType }"
                  @click="selectNetworkType(item.networkType)"
                >
                  {{ item.networkType }} 요금제
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="s_category_wrap">
          <div class="s_category">
            <ul>
              <li @click="speedPopupOpen">
                <img
                  :src="require(`@/assets/front/images/mobile/i_list_qu_s.svg`)"
                  alt=""
                />
              </li>
              <li></li>
              <li
                v-for="(item, index) in mobilePlanCategory.categories"
                :key="index"
              >
                <p
                  :class="{ on: categoryId == item.categoryId }"
                  @click="selectCategory(item.categoryId)"
                >
                  {{ item.categoryName }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="list_con_wrap">
        <div class="list_con" :class="{ top_fixed: isTabFixed }">
          <div class="list_sort_wrap">
            <div class="list_sort" @click="paymentSortOpen">
              <div class="list_sort_txt">{{ paymentSortTxt }}</div>
              <div class="list_sort_img">
                <img
                  :src="
                    require(`@/assets/front/images/mobile/i_ar_list_order.png`)
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
          <div v-if="mobilePlans || mobilePlans != null">
            <div
              class="list_payment"
              v-for="(item, index) in mobilePlans"
              :key="index"
            >
              <div
                class="d_info"
                @click="paymentInfo(item.planId, item.planName, item.price)"
              >
                <div class="d_txt_1">{{ item.planName }}</div>
                <div class="d_txt_2">
                  <div class="d_txt_list">
                    <div class="list_1">
                      <img
                        :src="
                          require(`@/assets/front/images/mobile/i_phonefee_op_phone.svg`)
                        "
                        alt=""
                      />
                    </div>
                    <div class="list_2">{{ item.voice }}</div>
                  </div>
                  <div class="d_txt_list">
                    <div class="list_1">
                      <img
                        :src="
                          require(`@/assets/front/images/mobile/i_phonefee_op_msg.svg`)
                        "
                        alt=""
                      />
                    </div>
                    <div class="list_2">{{ item.sms }}</div>
                  </div>
                  <div class="d_txt_list">
                    <div class="list_1">
                      <img
                        :src="
                          require(`@/assets/front/images/mobile/i_phonefee_op_wifi.svg`)
                        "
                        alt=""
                      />
                    </div>
                    <div class="list_2">{{ item.data }}</div>
                  </div>
                  <div class="d_txt_list">
                    <div class="list_1">
                      <img
                        :src="
                          require(`@/assets/front/images/mobile/i_phonefee_op_video.svg`)
                        "
                        alt=""
                      />
                    </div>
                    <div class="list_2">{{ item.video }}</div>
                  </div>
                </div>
                <div class="d_txt_3">
                  <div class="list_1">
                    <img
                      :src="
                        require(`@/assets/front/images/mobile/i_textinfo.svg`)
                      "
                      alt=""
                    />
                  </div>
                  <div class="list_2" v-if="item.explainCd == 'U_1M'">
                    {{ speedTxt.U_1M.content }}
                  </div>
                  <div class="list_2" v-if="item.explainCd == '1M'">
                    {{ speedTxt._1M.content }}
                  </div>
                  <div class="list_2" v-if="item.explainCd == '3M'">
                    {{ speedTxt._3M.content }}
                  </div>
                  <div class="list_2" v-if="item.explainCd == '5M'">
                    {{ speedTxt._5M.content }}
                  </div>
                  <div class="list_2" v-if="item.explainCd == 'O_10M'">
                    {{ speedTxt.O_10M.content }}
                  </div>
                </div>
                <div class="d_txt_4">
                  <span>월정액</span>{{ toCurrency(item.price) }}원
                </div>
                <div class="d_txt_5">
                  <span>공시지원</span>{{ toCurrency(item.supportMoney) }}원
                </div>
              </div>
            </div>
          </div>
          <div v-else class="list_empty">
            <div class="empty_img">
              <img src="@/assets/front/images/mobile/i_empty_n.svg" alt="" />
            </div>
            <div class="empty_txt">검색 결과가 없습니다.</div>
          </div>
        </div>
      </div>
    </div>
    <PaymentDetailModal
      ref="paymentDetailModal"
      @close="closePaymentDetailModal"
      @select="selectInfo"
      :mobilePlanDetail="mobilePlanDetail.content"
    ></PaymentDetailModal>
    <PaymentSortModal
      :show="isPaymentSortOpen"
      @close="paymentSortModalClose"
      ref="paymentSortModal"
    />
    <SpeedPopupModal :show="speedPopup" @close="speedPopupClose" />
  </main>
</template>

<script>
import PaymentSortModal from '@/common/components/mobile/modal/PaymentSortModal';
import SpeedPopupModal from '@/common/components/mobile/modal/SpeedPopupModal';
import PaymentDetailModal from '@/common/components/mobile/PaymentDetail.vue';
import * as util from '@common/lib/common/utils.js';
import DesignPopup2 from '@/common/components/modal/DesignPopup2';
import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import * as shopGetters from '@common/store/modules/shop/getters';
import { default as format } from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';

import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';
import AddressSearch from '@common/components/modal/AddressSearch';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

export default {
  name: 'payment',
  props: {
    show: Boolean,
    mobilePlanCategory: Object,
    mobilePlans: Array,
    deviceId: Number,
  },
  components: {
    PaymentDetailModal,
    PaymentSortModal,
    SpeedPopupModal,
  },
  data() {
    return {
      isTabFixed: false,
      paymentSortTxt: '퍼스 추천 순',
      paymentSortVal: 'RECOMMAND',
      isPaymentSortOpen: false,
      isCompleted: false,
      searchText: '',
      fetchCompleted: false,
      categoryId: 0,
      categoryName: '',
      networkType: '',
      planId: 0,
      planName: '',
      planPrice: 0,
      speedPopup: false,
      speedTxt: {
        U_1M: {
          title: '1Mbps 미만',
          content: '카톡 텍스트는 원활! 사진전송은 느려요.',
        },
        _1M: { title: '1Mbps', content: '3G 보다 조금 느린 정도에요.' },
        _3M: { title: '3Mbps', content: '영상을 720p 화질로 볼 수 있어요.' },

        _5M: {
          title: '5Mbps',
          content: '영상을 1080p 화질로 볼 수 있어요.',
        },

        O_10M: {
          title: '10Mbps',
          content: '영상을 고화질로 끊김 없이 볼 수 있어요.',
        },
      },
    };
  },
  async created() {
    this.isCompleted = true;
  },
  async mounted() {},
  computed: {
    ...mobileMapGetters({
      mobilePlanDetail: mobileTypes.MOBILE_PLAN_DETAIL,
    }),
    isCloseBtn() {
      if (this.searchText == '') {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mobileMapActions([mobileTypes.SELECT_MOBILE_PLAN_DETAIL]),
    toCurrency(val) {
      return util.toCurrency(val);
    },
    selectInfo() {
      // alert(3);
      this.$refs.paymentDetailModal.isOpen = false;
      this.$emit('paymentSel');
    },
    async paymentInfo(planId, planName, price) {
      let params = {
        id: planId,
        deviceId: this.deviceId,
      };
      await this[mobileTypes.SELECT_MOBILE_PLAN_DETAIL](params);

      this.planId = planId;
      this.planName = planName;
      this.planPrice = price;

      console.log(params);

      console.log('mobilePlanDetail');
      console.log(this.mobilePlanDetail);

      this.$refs.paymentDetailModal.isOpen = true;
    },
    closePaymentDetailModal() {
      this.$refs.paymentDetailModal.isOpen = false;
    },
    searchTextDel() {
      // alert(this.searchText);
      this.searchText = '';
      this.$refs.searchInput.focus();
      // alert(this.searchText);
      // this.isValue = false;
      this.fetchCompleted = false;
    },
    async searchTextSend() {
      this.fetchCompleted = false;
      await sleep(100);
      if (this.searchText.trim() == '') {
        this.searchText = '';
        // this.isValue = true;
        this.fetchCompleted = false;
        return false;
      } else if (this.searchText.trim().length < 2) {
        // this.isValue = true;
        this.fetchCompleted = false;
        return false;
      }

      this.searchText = this.searchText.trim();
      // alert(this.searchText);
      // await this.getListPageOne();
      // this.isValue = false;
    },
    async paymentSortModalClose(checked) {
      if (checked) {
        this.paymentSortTxt = this.$refs.paymentSortModal.selectSortTxt;
        this.paymentSortVal = this.$refs.paymentSortModal.selectSortVal;

        this.getPaymentList();
      }

      this.isPaymentSortOpen = false;
    },
    paymentSortOpen() {
      this.isPaymentSortOpen = true;
    },
    speedPopupOpen() {
      this.speedPopup = true;
    },
    speedPopupClose() {
      this.speedPopup = false;
    },
    selectNetworkType(networkType) {
      this.networkType = networkType;
      this.getPaymentList();
    },
    selectCategory(categoryId) {
      this.categoryId = categoryId;
      this.getPaymentList();
    },
    getPaymentList() {
      this.$parent.getPaymentList();
      setTimeout(() => {
        window.scrollTo(0, 240);
      }, 100);
    },
  },
};
</script>
